import { render } from "./WebsiteSetting.vue?vue&type=template&id=436e586c"
import script from "./WebsiteSetting.vue?vue&type=script&lang=js"
export * from "./WebsiteSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__